import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Tabs from 'components/application/Tabs';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import BookingSidePanelCourseTab from 'components/training/BookingSidePanelCourseTab';
import BookingSidePanelDetailsTab from 'components/training/BookingSidePanelDetailsTab';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function BookingSidePanelShow({
  booker,
  bookingGroupInfoBanner,
  course,
  domainBookingSource,
  domainBookingSourcePersonnelCollection,
  endOfListRef,
  isFetching,
  shouldShowPersonnel,
  sidePanelIsOpen,
  totalReadableBookingCount,
}) {
  const currentActor = useCurrentActor();

  const { t: i18nTCommon } = useTranslation('common');

  const [activeTab, setActiveTab] = useState('details');

  if (!sidePanelIsOpen && activeTab !== 'details') setActiveTab('details');

  const courseHasELearningCourse = !!course?.relationships.eLearningCourse.data;

  return (
    <Tabs
      activeTab={activeTab}
      modifiers={['panelled']}
      navClassName='tw-bg-grey-050'
      onTabClick={setActiveTab}
    >
      <BookingSidePanelDetailsTab
        booker={booker || null}
        bookingGroupInfoBanner={bookingGroupInfoBanner}
        course={course}
        domainBookingSource={domainBookingSource}
        domainBookingSourcePersonnelCollection={
          domainBookingSourcePersonnelCollection
        }
        endOfListRef={endOfListRef}
        id='details'
        isFetching={isFetching}
        key='detailsTab'
        label={
          courseHasELearningCourse ?
            i18nTCommon('bookings.enrolmentDetails')
          : i18nTCommon('bookings.bookingDetails')
        }
        shouldShowPersonnel={shouldShowPersonnel}
        totalReadableBookingCount={totalReadableBookingCount}
      />
      {currentActor.user.attributes.accessType !== 'personnel' && (
        <BookingSidePanelCourseTab
          course={course}
          id='courses'
          key='coursesTab'
          label={i18nTCommon('courses.courseDetails')}
        />
      )}
    </Tabs>
  );
}

BookingSidePanelShow.propTypes = {
  booker: resourceShape('simpleUser'),
  bookingGroupInfoBanner: PropTypes.node,
  course: resourceShape('course'),
  domainBookingSource: resourceShape(['booking', 'bookingGroup']),
  endOfListRef: PropTypes.func,
  isFetching: PropTypes.bool,
  domainBookingSourcePersonnelCollection: PropTypes.arrayOf(
    resourceShape('personnel'),
  ),
  shouldShowPersonnel: PropTypes.bool,
  sidePanelIsOpen: PropTypes.bool,
  totalReadableBookingCount: PropTypes.number,
};
